export default {
  title: "驗證電子郵箱",
  verifying: {
    title: "正在驗證您的電子郵箱",
    subtitle: "請稍候，我們正在驗證您的電子郵箱地址...",
  },
  sending: {
    title: "正在發送驗證郵件",
    subtitle: "請稍候，我們正在發送驗證郵件...",
  },
  sent: {
    title: "驗證郵件已發送",
    confirmationMessage: {
      beforeEmail: "我們已向 ",
      afterEmail: " 發送了一封確認郵件",
    },
    instruction: "請檢查您的收件箱並點擊連結以激活您的帳戶",
    troubleMessage: "沒有收到郵件？請檢查您的垃圾郵件資料夾或點擊下方「重新發送」",
    limitNote: "注意：每天最多可重新發送 3 次驗證郵件",
  },
  resent: {
    title: "驗證郵件已重新發送",
    confirmationMessage: {
      beforeEmail: "我們已向 ",
      afterEmail: " 重新發送了一封確認郵件",
    },
    instruction: "請檢查您的收件箱並點擊連結以激活您的帳戶",
    troubleMessage: "如果仍未收到，請檢查垃圾郵件或稍後再試",
    limitNote: "注意：每天最多可重新發送 3 次驗證郵件",
  },
  success: {
    title: "電子郵箱驗證成功",
    subtitle: "您的電子郵箱已成功驗證。您現在可以登入您的帳戶。",
    button: "前往登入",
    autoRedirectMessage: "{seconds} 秒後自動跳轉到儀表板...",
  },
  error: {
    title: "電子郵箱驗證失敗",
    subtitle: "驗證過程中發生錯誤。請稍後再試。",
  },
  resending: "正在重新發送...",
  resendAvailableIn: "重新發送倒數 {seconds} 秒",
  resendVerificationEmail: "重新發送驗證郵件",
  verificationFailed: "電子郵箱驗證失敗",
  verificationError: "驗證過程中發生錯誤",
  pleaseWait: "請等待 {seconds} 秒後再重新發送",
  dailyLimitReached: "已達到每日重新發送限制。請明天再試。",
  resentSuccess: "驗證郵件重新發送成功",
  resendFailed: "驗證郵件重新發送失敗",
  invalidRequest: "無效請求",
  remainingAttempts: "今天還剩 {count} 次嘗試機會",
};
